import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Table, Container } from 'reactstrap';
import * as dailyLogEntryActions from '../../actions/dailyLogEntryActions';
import DailyLogEntry from './DailyLogEntry';
import moment from 'moment';

class DailyLogEntryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logEntries: props.logEntries.sort(function (a, b) {
        return new Date(a.entryTime) - new Date(b.entryTime);
      }),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.logEntries) {
      if (this.props.logEntries !== nextProps.logEntries) {
        this.setState({
          logEntries: nextProps.logEntries.sort(function (a, b) {
            return new Date(a.entryTime) - new Date(b.entryTime);
          }),
        });
      }
    }
  }

  componentWillMount() {
    let currentLogId = Number.parseInt(this.props.currentDailyLog.id, 10);
    this.props.actions.loadEntriesByLogId(currentLogId);
  }

  redirectToAddEntryPage = () => {
    this.props.history.push(
      '/daily-log/' + this.props.currentDailyLog.id + '/daily-log-entry/'
    );
  };

  render() {
    const logDate = moment(this.props.currentDailyLog.logDate).format(
      'ddd, MMM Do YYYY'
    );
    const { logEntries } = this.state;
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Daily Log for {logDate}</h1>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Button
                className="primary mb-2"
                onClick={this.redirectToAddEntryPage}
              >
                Add
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {logEntries.length > 0 ? (
                <Table>
                  <thead>
                    <tr>
                      {/*<th>ID</th>*/}
                      <th>Time</th>
                      <th>Entry</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logEntries.map((entry) => (
                      <DailyLogEntry key={entry.id} logEntry={{ ...entry }} />
                    ))}
                  </tbody>
                </Table>
              ) : (
                <h4 className="mt-4">No log entries found</h4>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

DailyLogEntryPage.propTypes = {
  currentDailyLog: PropTypes.object,
  actions: PropTypes.object.isRequired,
};

function getDailyLogById(logs, id) {
  const log = logs.filter((log) => log.id === id);
  if (log) return log[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const logId = Number.parseInt(id, 10);

  let currentLog = {
    id: '',
    logDate: '',
    userId: '',
  };

  if (logId && state.dailyLogs.length > 0) {
    currentLog = getDailyLogById(state.dailyLogs, logId);
  }

  return {
    currentDailyLog: currentLog,
    logEntries: state.dailyLogEntries,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(dailyLogEntryActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DailyLogEntryPage)
);



// WEBPACK FOOTER //
// ./src/components/daily-log/DailyLogEntryPage.js